import React from 'react';
import NavBar from '../components/NavBar';
import './BookingDetailsPage.css';
import API from '../API';
import StepProgressBar from 'react-step-progress';
import 'react-step-progress/dist/index.css';
import BookingDetailsPanel from '../components/BookingDetailsPanel';


const step1Content = <h1>Step 1 Content</h1>;
const step2Content = <h1>Step 2 Content</h1>;
const step3Content = <h1>Step 3 Content</h1>;

export default class BookingDetailsPage extends React.Component {

    constructor(props) {
        super(props);

        var v = window.location.pathname.split("/");
        

        this.state = {loaded: false,error: undefined}

        
        API.fetchClient("getorder", {_id: v[2]}).then((order) => {
            console.log(order);

            if(order.error) {

            } else {
                this.order = order;
                this.setState({loaded: true});
            }
        });
    }

    render() {

        if(!this.state.loaded) return <></>


        return( 
        <div style={{paddingTop:0,display:"flex",flex:1}}>
            <NavBar />
        
            <div className='bookingsRoot'>
                <p style={{fontSize:30, fontWeight:"600", marginBottom:20}}>Sipariş #{this.order._id.substring(18).toUpperCase()}</p>


                

                <BookingDetailsPanel order={this.order} />
                <div className='bookingsParent'>
                    <p style={{marginBottom:20}}>Adres bilgileri</p>


                    {[this.order.from,...this.order.waypoints, this.order.to].map((waypoint, i) => <div className='waypointRoot' key={i}>
                    <div style={{position:"relative", display:"flex", justifyContent:"center"}}>
                    <svg
      width="40px"
      height="40px"
      viewBox="0 150 700 400"
    >
      <path
        fillRule="evenodd"
        fill='#3c9cd7'
        d="M558.32 176.96c20.16 197.87-159.04 350.93-204.59 383.79-104.54-74.668-213.55-218.03-213.55-350.93C140.18 93.34 234.258.01 349.99.01c104.54 0 191.15 76.906 207.57 176.96zM350 87.358c57.492 0 104.54 47.039 104.54 104.54 0 57.492-47.039 103.79-104.54 103.79-57.492 0-103.79-47.039-103.79-103.79 0-57.492 47.039-104.54 103.79-104.54z"
      ></path>
      
    </svg>
    
            <div className='breakerDiv'></div>
    </div>
                <div className='breakerRoot'>
                        <div style={{display:"flex",flexDirection:"column"}}>
                            <p style={{marginTop:5}}>{waypoint.Label}</p>
                            <p style={{color:"#c0c3cf"}}>{API.getDescription(waypoint) != "" && API.getDescription(waypoint)}</p>
                            
                        </div>
                        </div>
                    </div>)}        
                </div>

            </div>

        </div>)
    }

}